module.exports = __webpack_public_path__ + "img/r7.15869601.jpg";